export * from '@flipster/socket/r230522/details';
